export const parseAmount = (value: string | number) => parseFloat(value?.toString().replace(/[^\d]/g, '.'))
